import {
    MOVE_TO_ANOTHER_ACCOUNT_REQUEST,
    MOVE_TO_ANOTHER_ACCOUNT_RESULT,
    MOVE_TO_ANOTHER_ACCOUNT_OPEN_MODAL,
    MOVE_TO_ANOTHER_ACCOUNT_CLOSE_MODAL,
    MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST,
    MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_RESULT,
    MOVE_TO_ANOTHER_ACCOUNT_SET_DEVICE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    keyFob: null,
    keyFobs: [],
    selectedKeyFobs: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case MOVE_TO_ANOTHER_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case MOVE_TO_ANOTHER_ACCOUNT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case MOVE_TO_ANOTHER_ACCOUNT_OPEN_MODAL:
            return { ...state, openModal: true, selectedKeyFobs: action.payload }

        case MOVE_TO_ANOTHER_ACCOUNT_CLOSE_MODAL:
            return { ...state, openModal: false }

        case MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_REQUEST:
            return { ...state, loading: true }

        case MOVE_TO_ANOTHER_ACCOUNT_GET_KEYFOB_RESULT:
            return { ...state, loading: false, keyFob: action.payload }

        case MOVE_TO_ANOTHER_ACCOUNT_SET_DEVICE:
            return { ...state, keyFobs: action.payload }


        case CLEAR_REDUX:
            return ["", "MOVE_TO_ANOTHER_ACCOUNT"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};